function shouldShowMerchantProfileEnableFallback(profile, readinessReady, paymentReady) {
  if (!profile || !profile.id) {
    return false;
  }

  if (Number(profile.is_enabled) === 1 || paymentReady) {
    return false;
  }

  return readinessReady === true;
}

module.exports = {
  shouldShowMerchantProfileEnableFallback,
};
